import api from './api';

// Session-cached module entitlements (CRM/DMS nav visibility). The server-side
// route gate stays the security boundary — this only stops the UI re-asking
// "what can I see?" on EVERY navigation, which made gated nav items pop in late
// on each page. Pattern: instant from cache (memory, seeded from sessionStorage
// so even a hard refresh paints right), then a quiet background refresh so an
// entitlement flip still shows up on the next navigation without re-login.
// Cache is keyed to the auth token: a new login never sees the old user's nav.

const SS_KEY = 'dfEntitlements';
let memory = null;        // { token, data }
let inflight = null;

function currentToken() {
  return localStorage.getItem('token') || '';
}

export function seedEntitlements() {
  const token = currentToken();
  if (memory && memory.token === token) return memory.data;
  try {
    const stored = JSON.parse(sessionStorage.getItem(SS_KEY) || 'null');
    if (stored && stored.token === token) {
      memory = stored;
      return stored.data;
    }
  } catch (_) { /* corrupt storage — fall through to fetch */ }
  return null;
}

export function refreshEntitlements(onUpdate) {
  const token = currentToken();
  if (!token) return;
  if (inflight) {
    // Another consumer (usually Layout — its child effects run first) already
    // started the fetch. Chain this caller's callback onto it instead of
    // silently dropping it — dropping left a page's local entitlements state
    // stale until the next navigation whenever it mounted alongside Layout on
    // a cold cache.
    if (onUpdate) {
      inflight.then(() => {
        if (memory && memory.token === currentToken()) onUpdate(memory.data);
      });
    }
    return;
  }
  inflight = api.get('/entitlements')
    .then((r) => {
      const data = r.data || {};
      memory = { token, data };
      try { sessionStorage.setItem(SS_KEY, JSON.stringify(memory)); } catch (_) {}
      if (onUpdate) onUpdate(data);
    })
    .catch(() => {})
    .finally(() => { inflight = null; });
}
